import { createReducer } from 'typesafe-actions';
import {
  authFlow,
  clearServiceHealthChecks,
  hideInvalidConfiguration,
  type ServiceActionType,
  saveServiceRoutine,
  setBootstrapDialogProvider,
  setServiceHealthCheck,
  setShouldClearServiceHealthChecks,
  showInvalidConfiguration,
  toggleBootstrapDialog
} from './actions';
import type { ServiceHealth } from './types';

export type ServiceState = {
  bootstrapDialogOpen: boolean;
  bootstrapDialogProvider: string;
  bootstrapDialogTypes: string[];
  loading: boolean;
  provider: string;
  shouldClearHealthChecks: boolean;
  healthChecks: Record<string, ServiceHealth | undefined>;
  invalidConfigurationDialogContent: ServiceHealth | null;
};

export const initialState: ServiceState = {
  bootstrapDialogOpen: false,
  bootstrapDialogProvider: '',
  bootstrapDialogTypes: [],
  loading: false,
  provider: '',
  shouldClearHealthChecks: false,
  healthChecks: {},
  invalidConfigurationDialogContent: null
};

export const reducer = createReducer<ServiceState, ServiceActionType>(initialState)
  .handleAction(authFlow.requested, (state, { payload }) => ({
    ...state,
    loading: true,
    providerName: payload.providerName
  }))
  .handleAction(authFlow.fulfilled, (state) => ({
    ...state,
    loading: false,
    providerName: ''
  }))
  .handleAction(authFlow.cancelled, (state) => ({ ...state, loading: false }))
  .handleAction(authFlow.rejected, (state) => ({ ...state, loading: false }))
  .handleAction(toggleBootstrapDialog, (state, { payload }) => ({
    ...state,
    bootstrapDialogOpen: payload
  }))
  .handleAction(setBootstrapDialogProvider, (state, { payload }) => ({
    ...state,
    bootstrapDialogProvider: payload
  }))
  .handleAction(saveServiceRoutine.requested, (state) => ({
    ...state,
    loading: true
  }))
  .handleAction(saveServiceRoutine.fulfilled, (state) => ({
    ...state,
    loading: false
  }))
  .handleAction(saveServiceRoutine.cancelled, (state) => ({
    ...state,
    loading: false
  }))
  .handleAction(saveServiceRoutine.rejected, (state) => ({
    ...state,
    loading: false
  }))
  .handleAction(setServiceHealthCheck, (state, { payload }) => {
    return {
      ...state,
      healthChecks: {
        ...state.healthChecks,
        [payload.serviceId]: payload
      }
    };
  })
  .handleAction(setShouldClearServiceHealthChecks, (state) => {
    return {
      ...state,
      shouldClearHealthChecks: true
    };
  })
  .handleAction(clearServiceHealthChecks, (state) => {
    return {
      ...state,
      shouldClearHealthChecks: false,
      healthChecks: {}
    };
  })
  .handleAction(showInvalidConfiguration, (state, { payload }) => ({
    ...state,
    invalidConfigurationDialogContent: payload
  }))
  .handleAction(hideInvalidConfiguration, (state) => ({
    ...state,
    invalidConfigurationDialogContent: null
  }));
